import withErrorFallback from "@components/ErrorBoundary/withErrorFallback";

import Header from "./Header";
import HeaderFallback from "./HeaderFallback";

export default withErrorFallback(Header, HeaderFallback);
